import { ToastOptions, TypeOptions } from 'react-toastify';

const CommonConfig: ToastOptions = {
  autoClose: 1500,
  pauseOnFocusLoss: false,
  position: 'top-right',
  style: { fontSize: 'small' },
  theme: 'light',
};

type ToastConfigModel = Record<TypeOptions, ToastOptions>;

export const ToastConfig: ToastConfigModel = {
  default: {
    ...CommonConfig,
    style: {
      ...CommonConfig.style,
      color: 'black',
    },
    type: 'default',
  },
  error: {
    ...CommonConfig,
    autoClose: 3000,
    closeOnClick: true,
    draggable: false,
    type: 'error',
  },
  info: {
    ...CommonConfig,
    type: 'info',
  },
  success: {
    ...CommonConfig,
    type: 'success',
  },
  warning: {
    ...CommonConfig,
    type: 'warning',
  },
};
